import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LoginRequest } from '../../../core/models/auth.model';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: props<LoginRequest>(),
    'Login Success': props<{
      token: string;
      refreshToken: string | null;
      userName: string;
      role: string;
      publicId: string;
      status: string | null;
    }>(),
    'Login Failure': props<{ error: string }>(),
    'Tokens Renewed': props<{ token: string; refreshToken: string | null }>(),
    'Session Expired': props<{ returnUrl: string }>(),
    // Another tab closed the session: reset this tab without writing anything back to storage.
    'Session Ended Elsewhere': emptyProps(),
    'Status Refreshed': props<{ status: string | null }>(),
    'Load Permissions': emptyProps(),
    'Permissions Loaded': props<{
      userType: string;
      roles: string[];
      permissions: string[];
    }>(),
    'Permissions Load Failure': emptyProps(),
    Logout: emptyProps(),
    Init: emptyProps(),
  },
});
